"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ComgatePaymentGatewayActionsProvider = _interopRequireDefault(require("../ComgatePaymentGatewayActionsProvider"));

var _ComgatePaymentGatewayContext = _interopRequireDefault(require("./ComgatePaymentGatewayContext"));

function ComgatePaymentGatewayProvider(_ref) {
  var cacheHook = _ref.cacheHook,
      children = _ref.children,
      clientCode = _ref.clientCode,
      serviceNames = _ref.serviceNames,
      uiRouteBase = _ref.uiRouteBase;
  return /*#__PURE__*/_react.default.createElement(_ComgatePaymentGatewayContext.default.Provider, {
    value: {
      cacheHook: cacheHook,
      clientCode: clientCode,
      serviceNames: serviceNames,
      uiRouteBase: uiRouteBase
    }
  }, /*#__PURE__*/_react.default.createElement(_ComgatePaymentGatewayActionsProvider.default, null, children));
}

process.env.NODE_ENV !== "production" ? ComgatePaymentGatewayProvider.propTypes = {
  /**
   * Hook funkce vracejici cache.
   */
  cacheHook: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
  children: _propTypes.default.node,
  clientCode: _propTypes.default.string,
  serviceNames: _propTypes.default.shape({
    comgatePaymentGateway: _propTypes.default.shape({
      get: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      list: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      remove: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      serviceName: _propTypes.default.string,
      update: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
      version: _propTypes.default.string
    })
  }),
  uiRouteBase: _propTypes.default.string
} : void 0;
ComgatePaymentGatewayProvider.defaultProps = {
  cacheHook: undefined,
  children: null,
  clientCode: 'api',
  serviceNames: undefined,
  uiRouteBase: '/comgatePaymentGateway'
};
var _default = ComgatePaymentGatewayProvider;
exports.default = _default;